import createTrack from './index';

/*
埋点列表
 */

export const lsweb0001 = createTrack('lsweb0001', '登录页loading'); // 老师PC端-登录页loading
export const lsweb0002 = createTrack('lsweb0002', '登录成功'); // 老师PC端-
export const lsweb0003 = createTrack('lsweb0003', 'AI作文批改loading'); // 老师PC端-
export const lsweb0004 = createTrack('lsweb0004', 'AI作文批改-点击上传作文'); // 老师PC端-
export const lsweb0005 = createTrack('lsweb0005', 'AI作文批改-拖动图片'); // 老师PC端-
export const lsweb0006 = createTrack('lsweb0006', 'AI作文批改-点击识别'); // 老师PC端-
export const lsweb0007 = createTrack('lsweb0007', 'AI作文批改-修改文本'); // 老师PC端-
export const lsweb0008 = createTrack('lsweb0008', 'AI作文批改-点击开始批改'); // 老师PC端-
export const lsweb0009 = createTrack('lsweb0009', 'AI作文批改-批改结果页'); // 老师PC端-
export const lsweb0010 = createTrack('lsweb0010', 'AI作文批改-点击重新批改'); // 老师PC端-
export const lsweb0011 = createTrack('lsweb0011', 'AI作文批改-点击批改下一份'); // 老师PC端-

export const lsweb0012 = createTrack('lsweb0012', '官方资源库tab-loading'); 
export const lsweb0013 = createTrack('lsweb0013', '官方资源库tab-预览任意资源'); 
export const lsweb0014 = createTrack('lsweb0014', '官方资源库tab-单个资源-点击分享'); 
export const lsweb0015 = createTrack('lsweb0015', '官方资源库tab-单个资源-点赞'); 
export const lsweb0016 = createTrack('lsweb0016', '官方资源库tab-单个资源-点击保存到我的网盘tab'); 
export const lsweb0017 = createTrack('lsweb0017', '官方资源库tab-单个资源详情页loading'); 
export const lsweb0018 = createTrack('lsweb0018', '官方资源库tab-保存资源成功-点击立即查看'); 
export const lsweb0019 = createTrack('lsweb0019', '我的网盘tab- loading'); 
export const lsweb0020 = createTrack('lsweb0020', '我的网盘tab-文件tab-点击任意文件'); 
export const lsweb0021 = createTrack('lsweb0021', '我的网盘tab-文件tab-点击下载'); 
export const lsweb0022 = createTrack('lsweb0022', '我的网盘tab-文件tab-点击分享'); 
export const lsweb0023 = createTrack('lsweb0023', '我的网盘tab-文件tab-点击删除'); 
export const lsweb0024 = createTrack('lsweb0024', '我的网盘tab-文件tab-删除成功'); 
export const lsweb0025 = createTrack('lsweb0025', '我的网盘tab-文件tab-点击重命名'); 
export const lsweb0026 = createTrack('lsweb0026', '我的网盘tab-文件tab-重命名成功'); 






















